/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import SumDocsExcel from "./SumDocsExcel";

class MovesExcel extends Component {

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22735);
    }

    render() {

        return (<SumDocsExcel
            {...this.props}
            isMoves
            title={this.getText(22735)}
            reportName={"reports/DailySalesExcel.xls"}
            docTypeList={'50,51'}
        />)
    }

}

export default MovesExcel;